// extracted by mini-css-extract-plugin
module.exports = {"videosMain":"styles-module--videosMain--Fghg_","videocard":"styles-module--videocard--3CQME","date":"styles-module--date--1EM-g","description":"styles-module--description--1lJw9"};